import Web3 from 'web3'

const { ethereum } = window
const web3 = new Web3(ethereum)

export default web3

export const KAVA_CHAIN_ID = 2222
